export const gitVersion = {
  "tag": "v5.5.6",
  "commit": "cc649ff0e35ad158f7dfdbd01e1314c182fedb6e",
  "branch": "main"
}